import { IOverallProgress } from "@types";
import { ActionTypes } from "./types";

let INITIAL_STATE = {
  data: {
    goal_progress: {
      total_goals: 0,
      completed_goals: 0,
      progress: 0
    },
    plan_progress: {
      total_actions: 0,
      completed_actions: 0,
      progress: 0
    }
  } as IOverallProgress,
  loading: false,
  success: false,
  error: null
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.LOADING:
      return {
        ...state,
        loading: true,
      };

    case ActionTypes.SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
      };

    case ActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
